// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Third party imports
import { DxFormComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// constant imports
import { Constants } from '../../../../../_constants/constants';
import { MessageInterval } from '../../../../../_constants/messages-intervals';

// Service imports
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { InvoiceDetailsService } from '../../../_services/account-receivable/invoice-details.service';
import { CBSharedService } from '../../../_services/shared-services/cb-shared-service';

// Model imports
import { ARInvoiceDetailParameterDto } from '../../../_models/account-receivable/ar-invoice/ar-invoice-detail-parameter-dto';
import { ARInvoiceResultDto } from '../../../_models/account-receivable/ar-invoice/ar-invoice-result-dto';
import { ARInvoiceReverseParameterDto } from '../../../_models/account-receivable/ar-invoice/ar-invoice-reverse-parameter-dto';
import { ReverseEditorResultDto } from '../../../../../shared-module/_models/reverse-editor-result-dto';

@Component({
    selector: 'app-ar-invoice-reverse-editor',
    templateUrl: './ar-invoice-reverse-editor.component.html',
    styleUrls: ['./ar-invoice-reverse-editor.component.scss']
})
export class ARInvoiceReverseEditorComponent implements OnInit {
    @ViewChild('confirmForm', { static: false }) confirmForm: DxFormComponent;
    @Input() visible = false;
    @Input() invoiceDetails: ARInvoiceResultDto;
    @Input() invoiceDetailParam: ARInvoiceDetailParameterDto;
    @Output() onReverseEditorClose = new EventEmitter<boolean>();

    defaultLabelLocation: string = Constants.defaultFormLabelLocation;
    loadingVisible = false;

    closeIcon: string = IconConstants.CLOSE;
    saveIcon: string = IconConstants.CHECK_MARK;

    invoiceReverseParam: ARInvoiceReverseParameterDto;

    disableReverseButton = false;
    minDate: Date;

    constructor(
        private readonly invoiceDetailsService: InvoiceDetailsService,
        private readonly cbSharedService: CBSharedService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.populateEditor();
    }

    onHidden(): void {
        this.closeEditor(false);
    }

    onReverseClick(): void {
        if (Utils.notNullAndDefined(this.confirmForm) && Utils.notNullAndDefined(this.confirmForm.instance)) {
            const validator = this.confirmForm.instance.validate();

            if (Utils.isTrue(validator.isValid)) {
                // Disable reverse action button
                this.disableReverseButton = true;

                // Show loading
                this.loadingVisible = true;

                this.invoiceDetailsService.reverseARInvoice(this.invoiceReverseParam).subscribe(
                    () => {
                        notify('AR Invoice Reversed Successfully.', 'success', MessageInterval.successMsgInterval);

                        this.closeEditor(true);

                        // Hide loading
                        this.loadingVisible = false;
                    },
                    (error) => {
                        // Hide loading
                        this.loadingVisible = false;

                        // Display error
                        this.errorService.displayError(error);

                        this.closeEditor(false);
                    }
                );
            }
        }
    }

    private closeEditor(forceReload: boolean): void {
        this.visible = false;
        this.onReverseEditorClose.emit(forceReload);
    }

    private populateEditor(): void {
        if (Utils.notNullAndDefined(this.invoiceDetails) && Utils.notNullAndDefined(this.invoiceDetailParam)) {
            const param = new ARInvoiceDetailParameterDto();
            param.managementCompanyId = this.invoiceDetailParam.managementCompanyId;
            param.communityId = this.invoiceDetailParam.communityId;
            param.invoiceId = this.invoiceDetailParam.invoiceId;
            this.cbSharedService.getEntityReverseEditor(param).subscribe((result: ReverseEditorResultDto) => {
                this.minDate = result.minReverseDate;
                this.invoiceReverseParam = new ARInvoiceReverseParameterDto();
                this.invoiceReverseParam.reverseDate = result.reverseDate;
                this.invoiceReverseParam.invoiceId = this.invoiceDetailParam.invoiceId;
                this.invoiceReverseParam.managementCompanyId = this.invoiceDetailParam.managementCompanyId;
                this.invoiceReverseParam.communityId = this.invoiceDetailParam.communityId;
            });
        }
    }
}
